import React from 'react';
import {toAbsoluteUrl} from '../../../../../../_metronic/_helpers';
import {Button, Dropdown} from 'react-bootstrap';
import PopupAddReceipt from '../PopupAddReceipt';
import PopupSendMail from '../PopupSendMail';
import DownloadInvoice from '../DownloadInvoice';
import DownloadReceipt from '../DownloadReceipt';
import PopupSendReminder from '../PopupSendReminder';
import PopupReopenInvoice from '../PopupReopenInvoice';
import PopupCancelInvoice from '../PopupCancelInvoice';
import PopupCreateReceipt from '../PopupCreateReceipt/components';
import PopupConvertToType1 from "../PopupConvertToType1";
import PopupConvertToType2 from "../PopupConvertTo2/components";

const CustomToggle = React.forwardRef(({children, onClick}, ref) => (
  <Button
    variant="outline-primary"
    className={`btn btn-icon btn-light btn-sm custom-action-button`}
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    <img
      src={toAbsoluteUrl('/media/svg/Dots_brandColor.svg')}
      alt="more"
    />
  </Button>
));

const CustomDDItem = React.forwardRef(({children, style, className, 'aria-labelledby': labeledBy}, ref) => (
  <div className={`p-0 cursor-pointer border-bottom border-secondary ${className}`} style={style}
       ref={ref}>{children}</div>
));

export function InvoiceActionsColumnFormatter(cellContent) {

  return (
    <Dropdown autoClose={true}>
      <Dropdown.Toggle as={CustomToggle} id="dropdown-basic"/>
      <Dropdown.Menu alignRight={true}>
        <Dropdown.Item as={CustomDDItem}>
          <PopupAddReceipt cellContent={cellContent}/>
        </Dropdown.Item>
        <Dropdown.Item as={CustomDDItem}>
          <PopupSendMail invoiceTypeID={cellContent.type} invoiceNum={cellContent.num}/>
        </Dropdown.Item>
        <Dropdown.Item as={CustomDDItem}>
          <DownloadInvoice cellContent={cellContent}/>
        </Dropdown.Item>
        <Dropdown.Item as={CustomDDItem}>
          <DownloadReceipt cellContent={cellContent}/>
        </Dropdown.Item>
        <Dropdown.Item as={CustomDDItem}>
          <PopupSendReminder cellContent={cellContent}/>
        </Dropdown.Item>
        <Dropdown.Item as={CustomDDItem}>
          <PopupReopenInvoice cellContent={cellContent}/>
        </Dropdown.Item>
        <Dropdown.Item as={CustomDDItem}>
          <PopupCancelInvoice cellContent={cellContent}/>
        </Dropdown.Item>
        <Dropdown.Item as={CustomDDItem}>
          <PopupCreateReceipt {...cellContent}/>
        </Dropdown.Item>
        {cellContent.type === 8 && (
        <Dropdown.Item as={CustomDDItem}>
          <PopupConvertToType1 cellContent={cellContent}/>
        </Dropdown.Item>
        )}
        {cellContent.type === 8 && (
        <Dropdown.Item as={CustomDDItem}>
          <PopupConvertToType2 {...cellContent}/>
        </Dropdown.Item>
        )}
      </Dropdown.Menu>
    </Dropdown>
  )
}